import { createSlice } from "@reduxjs/toolkit";

const NavbarUserSlice = createSlice({
  name: "navbarUser",
  initialState: {
    subMenuData: [
      {
        id: 1,
        title: " ",
        path: "/dashboard/profile",
        hasSubNav: false,
        subNav: [],
      },
      {
        id: 2,
        title: " ناحیه کاربری",
        path: "/dashboard/user",
        hasSubNav: false,
        subNav: [],
      },
      {
        id: 3,
        title: "حساب‌های بانکی",
        path: "/dashboard/accounts",

        hasSubNav: true,
        subNav: [
          {
            id: 2,
            title: " حساب جدید",
            path: "/dashboard/accounts/new",
            icon: "addicon",
          },
        ],
      },
      // {
      //   id: 4,
      //   title: "امنیت",
      //   path: "/dashboard/security",

      //   hasSubNav: "false",
      //  subNav: []
      // },
      {
        id: 5,
        title: "اطلاع رسانی",
        path: "/dashboard/notices",

        hasSubNav: false,
        subNav: [],
      },
      {
        id: 6,
        title: "تیکت‌ها",
        path: "/dashboard/tickets",
        hasSubNav: true,
        subNav: [
          {
            id: 1,
            title: "تیکت جدید",
            path: "/dashboard/tickets/new",
            icon: "addicon",
          },
        ],
      },
      {
        id: 7,
        title: "لیست کسب وکار ها",
        path: "/dashboard/businesslist",

        hasSubNav: false,
        subNav: [],
      },
    ],
  },

  reducers: {
    callNavbarUser: (state, action) => {
      //  ////console.log(action,"action")
      state.subMenuData[0].title = action.payload.subMenuData.items[0]
        ? action.payload.subMenuData.items[0].first_name_fa +
          " " +
          action.payload.subMenuData.items[0].last_name_fa
        : "";
      //  ////console.log("payload" , action.payload);
    },
    callNavbarAccounts: (state, action) => {
      const AccountsArray = [];
      state.subMenuData[2].subNav.splice(0);

      // for (let index = 0; index < action.payload.subMenuData.length; index++) {
      //   let title= action.payload.subMenuData[index].account.name
      //   let id=action.payload.subMenuData[index].account.id
      //   AccountsArray.push({
      //     id: id,
      //     title: title,
      //     path: `/dashboard/accounts/${id}/`,
      //   icon: "cardicon"
      //   },)
      // }

      AccountsArray.push({
        id: 2,
        title: " حساب جدید",
        path: "/dashboard/accounts/new",
        icon: "addicon",
      });
      state.subMenuData[2].subNav = [...state.subMenuData[2].subNav, ...AccountsArray];

      ////console.log("payload callNavbarAccounts:", action.payload.subMenuData);
      ////console.log("AccountsArray: ", AccountsArray);
    },
  },
});

export const { callNavbarUser, callNavbarAccounts } = NavbarUserSlice.actions;
export default NavbarUserSlice.reducer;
